<template>
  <TermsConditionMain/>
</template>


<script>
import TermsConditionMain from '../components/terms-condition';
import { useHead } from '@vueuse/head';
import sanity from "../../sanity.js";
import { computed } from 'vue';

export default {
  name:'TermsAndConditions',
  components:{
    TermsConditionMain
  },
  data() {
    return {
      content: null
    }
  },
  methods: {
    async fetchData() {
      const query = `*[_type == "generic" && slug.current == "terms-and-conditions"][0]{
        title,
        seo {
          title,
          description,
          keywords,
          ogImage {
            asset->{
              url
            }
          }
        }
      }`;
      this.loading = true;
      try {
        const content = await sanity.fetch(query);
        this.loading = false;
        this.content = content;
      } catch (error) {
        this.error = error;
      }
    },
  },
  async created() {
    await this.fetchData();

    // Call useHead after data is loaded, using computed for reactivity
    useHead({
      title: computed(() => `${this.content?.seo?.title || this.content?.title || 'Terms and Conditions'} | Marshall Print`),
      meta: computed(() => [
        { name: 'description', content: this.content?.seo?.description },
        { name: 'keywords', content: this.content?.seo?.keywords },
        // { property: 'og:title', content: this.content?.seo?.title },
        // { property: 'og:description', content: this.content?.seo?.description },
        // { property: 'og:image', content: this.content?.seo?.ogImage?.asset?.url },
      ])
    });
  }
}
</script>
